// extracted by mini-css-extract-plugin
export var Modal = "Modal-module--Modal--vWf1Z";
export var ModalCenterContent = "Modal-module--ModalCenterContent--D91JA";